import { properties } from "../../constants/Propertise";

export const DashboardComponentsNav = [
  {
    icon: "pe-7s-home",
    label: "HOME",
    content: [
      // {
      //     label: properties.dashboardText,
      //     to: `${process.env.PUBLIC_URL}/externalDashboard`
      // },
      {
        label: properties.applicationsText,
        to: `${process.env.PUBLIC_URL}/applicationsList`,
      },
      // {
      //     label: "Neo Gen-AI",
      //     to: `${process.env.PUBLIC_URL}/aichatbot`
      // },
    ],
  },
];
